<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <!-- <el-card style="max-height:340px">
              <Leftbar></Leftbar>
            </el-card> -->
            <el-card class="rightContent">
              <h3>
                {{ $t("profile.editPassword") }}
              </h3>
              <el-divider></el-divider>
              <el-form
                :model="pwdForm"
                :rules="rules"
                ref="pwdForm"
                label-width="auto"
                class="demo-personInfoEditForm"
              >
                <el-form-item :label="$t('profile.oldPsd')" prop="oldPassword">
                  <el-input
                    v-model="pwdForm.oldPassword"
                    type="password"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('profile.newPsd')" prop="password">
                  <el-input
                    type="password"
                    v-model="pwdForm.password"
                    style="width: 300px"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('profile.confirmPsd')"
                  prop="checkPass"
                >
                  <el-input
                    type="password"
                    v-model="pwdForm.checkPass"
                    style="width: 300px"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item label="" prop="">
                  <el-button type="primary" @click="savePwd('pwdForm')"
                    >{{ $t("button.save") }}
                  </el-button>
                  <el-button type="danger" @click="backToProfile"
                    >{{ $t("button.back") }}
                  </el-button>
                </el-form-item>
              </el-form>
            </el-card>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Leftbar from "../../components/newComponent/Leftbar";
import { userPwdChange } from "../../api/user";
import {
  taskTypeFilter,
  taskStateFilter,
  taskBadgeFilter,
} from "../../utils/filter";
export default {
  components: {
    Leftbar,
  },
  name: "profile",
  bodyClass: "index-page",
  props: {},
  filters: {
    taskTypeFilter,
    taskStateFilter,
    taskBadgeFilter,
  },
  data() {
    return {
      personInfoEditForm: {
        name: "慕测科技",
        identity: 0,
        phone: "18851111391",
        email: "824365307@qq.com",
        studentId: "MF21320173",
        teacher: "824365307@qq.com",
      },
      pwdForm: {
        oldPassword: "",
        password: "",
        checkPass: "",
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('已保存!');
          this.$router.push("/profile");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    savePwd() {
      let that = this;
      // return
      userPwdChange(
        this.pwdForm.password,
        this.pwdForm.oldPassword,
        localStorage.getItem("uid"),
      ).then((res) => {
        if (res.status == "failed") {
          this.$notify({
            type: "error",
            title: that.$t("common.fail"),
            duration: 5000,
          });
          return;
        } else {
          this.$notify({
            type: "success",
            title: that.$t("common.success"),
            duration: 5000,
          });
          this.$router.push("/profile");
        }
      });
    },
    backToProfile() {
      this.$router.push("/profile");
    },
  },
  computed: {
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`,
      };
    },
    rules() {
      let that = this;
      let validatePass = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(that.$t("profile.newPsdNull")));
        } else {
          if (this.pwdForm.checkPass !== "") {
            this.$refs.pwdForm.validateField("checkPass");
          }
          callback();
        }
      };
      let validateoldPassword = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(that.$t("profile.oldPsdNull")));
        } else {
          if (this.pwdForm.checkPass !== "") {
            this.$refs.pwdForm.validateField("oldPassword");
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(that.$t("profile.confirmPsdNull")));
        } else if (value !== this.pwdForm.password) {
          callback(new Error(that.$t("profile.psdDiffer")));
        } else {
          callback();
        }
      };

      return {
        oldPassword: [{ validator: validateoldPassword, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      };
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
